import { useMemo } from 'react'

export default function useDataTransform(props) {
  return useMemo(
    () => ({
      resource: props.resource,
      onComplete: props.onComplete,
      appointment_type_id: null,
    }),
    [props.resource, props.onComplete]
  )
}
